import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import kexProfilesState from './state';
export const kexProfilesSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => kexProfilesState);
    },
    initialState: kexProfilesState,
    name: 'kexProfiles',
    reducers: {
        errorReceiveCreateKEXProfile: state => {
            state.requestingCreateKEXProfile = false;
        },
        errorReceiveModifyKEXProfile: state => {
            state.requestingModifyKEXProfile = false;
        },
        errorReceiveRemoveKEXProfile: state => {
            state.requestingRemoveKEXProfile = false;
        },
        errorReceiveSourceKEXProfile: state => {
            state.requestingSourceKEXProfile = false;
            state.sourceKEXProfile = undefined;
        },
        errorReceiveTargetKEXProfile: state => {
            state.requestingTargetKEXProfile = false;
            state.targetKEXProfile = undefined;
        },
        failedReceiveCreateKEXProfile: state => {
            state.requestingCreateKEXProfile = false;
        },
        failedReceiveModifyKEXProfile: state => {
            state.requestingModifyKEXProfile = false;
        },
        failedReceiveRemoveKEXProfile: state => {
            state.requestingRemoveKEXProfile = false;
        },
        failedReceiveSourceKEXProfile: state => {
            state.requestingSourceKEXProfile = false;
            state.sourceKEXProfile = undefined;
        },
        failedReceiveTargetKEXProfile: state => {
            state.requestingTargetKEXProfile = false;
            state.targetKEXProfile = undefined;
        },
        receiveCreateKEXProfile: {
            prepare: kexProfile => {
                return {
                    payload: {
                        kexProfile
                    }
                };
            },
            reducer: (state, action) => {
                const { kexProfile } = action.payload;
                state.requestingCreateKEXProfile = false;
                state.sourceKEXProfile = kexProfile;
            }
        },
        receiveModifyKEXProfile: {
            prepare: kexProfile => {
                return {
                    payload: {
                        kexProfile
                    }
                };
            },
            reducer: (state, action) => {
                const { kexProfile } = action.payload;
                state.requestingModifyKEXProfile = false;
                state.sourceKEXProfile = kexProfile;
            }
        },
        receiveRemoveKEXProfile: state => {
            state.requestingRemoveKEXProfile = false;
            state.sourceKEXProfile = undefined;
        },
        receiveSourceKEXProfile: {
            prepare: kexProfile => {
                return {
                    payload: {
                        kexProfile
                    }
                };
            },
            reducer: (state, action) => {
                const { kexProfile } = action.payload;
                state.requestingSourceKEXProfile = false;
                state.sourceKEXProfile = kexProfile;
            }
        },
        receiveTargetKEXProfile: {
            prepare: kexProfile => {
                return {
                    payload: {
                        kexProfile
                    }
                };
            },
            reducer: (state, action) => {
                const { kexProfile } = action.payload;
                state.requestingTargetKEXProfile = false;
                state.targetKEXProfile = kexProfile;
            }
        },
        requestCreateKEXProfile: {
            prepare: (kexProfilePayload, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        kexProfilePayload
                    }
                };
            },
            reducer: state => {
                state.requestingCreateKEXProfile = true;
            }
        },
        requestModifyKEXProfile: {
            prepare: (kexProfileId, kexProfilePayload, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        kexProfileId,
                        kexProfilePayload
                    }
                };
            },
            reducer: state => {
                state.requestingModifyKEXProfile = true;
            }
        },
        requestRemoveKEXProfile: {
            prepare: (kexProfileId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        kexProfileId
                    }
                };
            },
            reducer: state => {
                state.requestingRemoveKEXProfile = true;
            }
        },
        requestSourceKEXProfile: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingSourceKEXProfile = true;
            }
        },
        requestTargetKEXProfile: {
            prepare: (targetOrganization, kexProfileId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        kexProfileId,
                        targetOrganization
                    }
                };
            },
            reducer: state => {
                state.requestingTargetKEXProfile = true;
            }
        },
        resetKEXProfiles: () => kexProfilesState,
        resetTargetKEXProfile: state => {
            state.requestingTargetKEXProfile = false;
            state.targetKEXProfile = undefined;
        }
    }
});
export const { errorReceiveCreateKEXProfile, errorReceiveModifyKEXProfile, errorReceiveRemoveKEXProfile, errorReceiveSourceKEXProfile, errorReceiveTargetKEXProfile, failedReceiveCreateKEXProfile, failedReceiveModifyKEXProfile, failedReceiveRemoveKEXProfile, failedReceiveSourceKEXProfile, failedReceiveTargetKEXProfile, receiveCreateKEXProfile, receiveModifyKEXProfile, receiveRemoveKEXProfile, receiveSourceKEXProfile, receiveTargetKEXProfile, requestCreateKEXProfile, requestModifyKEXProfile, requestRemoveKEXProfile, requestSourceKEXProfile, requestTargetKEXProfile, resetKEXProfiles, resetTargetKEXProfile } = kexProfilesSlice.actions;
export default kexProfilesSlice.reducer;
